import { _notNil } from '@/littledash';
import type { ReactElement } from 'react';

export type Tab = {
  id: string;
  name: string;
  element: ReactElement;
};

export const getTabId = (search: string): string | null => {
  return new URLSearchParams(search).get('tab');
};

export const getTabIndex = (search: string, tabs: Array<Tab>): number => {
  const tabId = getTabId(search);
  if (_notNil(tabId)) {
    const tabIndex = tabs.findIndex((tab) => tab.id === tabId);
    return tabIndex >= 0 ? tabIndex : 0;
  }
  return 0;
};

/**
 * Triggers a browser download of a Blob via a synthesized anchor click. Used across the export
 * flow (ExportReadyToast, ExportDownloadConfirmation, ExportsList) to save the fetched blob under
 * the API-provided file name. Callers own the fetch + error handling — this helper only wraps the
 * DOM plumbing (object URL, anchor click, cleanup).
 */
export const triggerBrowserDownload = (blob: Blob, fileName: string): void => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};
